import React, { useState, useRef, useEffect } from "react";
import "../aseets/css/ConversationWall.css";

const ConversationWall = () => {
  const [open, setOpen] = useState(false);
  const cardRef = useRef(null);

  // Mouse parallax tilt
  useEffect(() => {
    const card = cardRef.current;
    if (!card || open) return;

    const handleMove = (e) => {
      const rect = card.getBoundingClientRect();
      const x = e.clientX - rect.left - rect.width / 2;
      const y = e.clientY - rect.top - rect.height / 2;

      card.style.transform = `
        rotateX(${(-y / 40).toFixed(2)}deg)
        rotateY(${(x / 40).toFixed(2)}deg)
        translateY(-6px)
      `;
    };

    const reset = () => {
      card.style.transform = "rotateX(0deg) rotateY(0deg) translateY(0)";
    };

    card.addEventListener("mousemove", handleMove);
    card.addEventListener("mouseleave", reset);

    return () => {
      card.removeEventListener("mousemove", handleMove);
      card.removeEventListener("mouseleave", reset);
    };
  }, [open]);

  return (
    <section className="gm-wall">
      {/* SUBTLE GRID */}
      <div className="gm-wall-grid" />

      {/* FLOATING CARD */}
      <div
        ref={cardRef}
        className={`gm-wall-card ${open ? "gm-wall-card-open" : ""}`}
        onClick={() => !open && setOpen(true)}
      >
        {!open && (
          <div className="gm-wall-intro">
            <span className="gm-wall-eyebrow">START A CONVERSATION</span>
            <h2 className="gm-wall-title">Let’s Talk</h2>
            <p className="gm-wall-sub">
              Tell us what you’re building.  
              We’ll help shape the direction.
            </p>
          </div>
        )}

        {open && (
          <div className="gm-wall-form">
            <h3>Let’s begin</h3>

            <form>
              <input type="text" placeholder="Your Name" />
              <input type="email" placeholder="Email Address" />
              <input type="text" placeholder="Company / Brand" />
              <textarea
                placeholder="What would you like to discuss?"
                rows="4"
              />
              <button type="submit">Start Conversation</button>
            </form>

            <span
              className="gm-wall-close"
              onClick={(e) => {
                e.stopPropagation();
                setOpen(false);
              }}
            >
              ✕
            </span>
          </div>
        )}
      </div>
    </section>
  );
};

export default ConversationWall;
